import { createCol } from 'react-native-col';
import { Box } from '../box';
export const Col = createCol(Box);
